var _rect, _rect2, _rect3, _rect4, _rect5, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 14,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 4.5 18.5)",
    stroke: "#B0B6BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 18,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 2.5 20.5)",
    stroke: "#B0B6BD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 16,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 3.5 9.5)",
    stroke: "#B0B6BD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 3,
    height: 7,
    rx: 0.5,
    stroke: "#B0B6BD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 3,
    height: 7,
    rx: 0.5,
    stroke: "#B0B6BD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5a6.5 6.5 0 1 1 13 0h-13Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5a6.5 6.5 0 1 1 13 0h-13Z",
    stroke: "#B0B6BD",
    strokeWidth: 2,
    mask: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.a96d3049de5dbddcc80df6acfa710d46.svg";
export { ForwardRef as ReactComponent };